export default __webpack_public_path__ + "static/media/show.a6758c39.svg";